import { UPDATE_DISCOUNT_MASTER } from "../../types/DiscountMasterType";
import axios from "axios";
import { toast } from "react-toastify";

const updateDiscountMasterAction = (data) => {
return {
	type: UPDATE_DISCOUNT_MASTER,
	payload: data,
};
};

export const updateDiscountMaster = (id, values) => {
return async (dispatch) => {
	try {
		const { data } = await axios({
			method: "put",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json;charset=UTF-8",
			},
			url: `discount-master/${id}`,
			data: {
				...values,
			},
		});
		dispatch(updateDiscountMasterAction(data));
		toast.success("Discount Master Updated");
		return {
			message: "success",
		};
	} catch (error) {
		toast.error(error.response?.data?.error || "Error in updating discount master");
		console.log(error.message);
	}
};
};
